/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import {
  useAddNotes,
  useGetTicketDetails,
  useSelfAssignTicket,
  useUpdateTicket,
} from "services/tickets";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import {
  useLookupCategories,
  useLookupCustomers,
  useLookupSubCategories,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { emptyTicket, StatusContext } from "../constants";
import { useUser } from "hooks/use-user";
import { disableTicketEditing, isCallCenterAgent } from "../utils";
import ResolutionNotes from "components/tickets/resolution-notes";
import { TicketDetailsHeader } from "components/tickets/ticket-details-header";

const emptyRequest = {
  ...emptyTicket,
  activityType: "Voice Of Staff",
  assignmentGroup: "Cash Admin",
};
export default function VoiceOfStaffTicketDetails() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const { status } = useContext(StatusContext);
  const user = useUser();
  const params = useParams();
  const navigate = useNavigate();
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();

  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useUpdateTicket();

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();
  const {
    mutate: addTicketNotes,
    data: addNotesResponse,
    isPending: addingNotes,
    error: addNotesError,
    reset: resetNotesRequest,
  } = useAddNotes();
  const {
    mutate: selfAssign,
    data: selfAssignRes,
    isPending: selfAssigning,
  } = useSelfAssignTicket();
  const form = useForm({
    defaultValues: { ...emptyRequest },
  });
  useEffect(() => {
    getCustomersList();
    onActivityTypeChange("Voice Of Staff");

    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  useEffect(() => {
    if (ticketDetailsRes && customersListRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = {
          ...ticketDetailsRes.data,
          employeeName: `${ticketDetailsRes.data.employeeTgId || ""}${
            ticketDetailsRes.data.employeeTgId &&
            ticketDetailsRes.data.employeeName
              ? " - "
              : ""
          }${ticketDetailsRes.data.employeeName || ""}`,
          isCustomerComplaint: ticketDetailsRes.data.isCustomerComplaint
            ? "Yes"
            : "No",
        };
        form.reset({ ...emptyRequest, region: _details.state, ..._details });

        if (ticketDetailsRes.data.activityType) {
          getCategories(ticketDetailsRes.data.activityType);
        }
        if (ticketDetailsRes.data.category) {
          getSubCategories({
            activityType: ticketDetailsRes.data.activityType,
            category: ticketDetailsRes.data.category,
          });
        }

        setTicketDetails({ ..._details });
        resetDetailsApi();
      }
    }

    if (createTicketRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (selfAssignRes) {
      user.Roles.includes("CC Calls")
        ? navigate(PATHS.allCalls)
        : navigate(PATHS.allServiceAndNonServiceCalls);
    }
  }, [
    createTicketRes,
    createTicketError,
    ticketDetailsRes,
    customersListRes,
    selfAssignRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    customerId: { required: "Please Enter Value" },
    customerTicketNo: {
      pattern: {
        value: /^[A-Za-z0-9\s]+$/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
    },
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    assigneeId: { required: "Please Enter Value" },
    creationChannel: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,

      remarks: _data.updatedRemarks || "",
      additionalRemarks: _data.additionalRemarks || "",

      assignmentGroup: _data.assignmentGroup || "",
    };
    createTicket(payload);
  };

  const onActivityTypeChange = (data) => {
    getCategories(data);
    form.setValue("category", "");
    form.setValue("subCategory", "");
  };
  const onCategoryChange = (data) => {
    form.setValue("subCategory", "");
    getSubCategories({
      activityType: form.getValues("activityType"),
      category: data,
    });
  };

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);

  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      ticketId: form.getValues("ticketId"),
    };
    addTicketNotes(payload);
  };
  const onSelfAssign = () => {
    selfAssign(ticketDetails.ticketId);
  };
  return (
    <>
      {gettingCustomersList ||
      creatingTicket ||
      gettingCategories ||
      gettingTicket ||
      selfAssigning ||
      gettingSubCategories ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <TicketDetailsHeader
          canSelfAssign
          isFormDisabled={isFormDisabled}
          isDirty={form.formState.isDirty}
          ticket={ticketDetails}
          onSave={form.handleSubmit(onSave)}
          onReset={onReset}
          onSelfAssign={onSelfAssign}
        />

        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Voice of Staff</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="alertDateTime"
                    label="Alert Date Time"
                    disabled
                    hideIcons
                  />
                </div>
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="TG Reference No"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createdBy"
                    label="Opened By"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    label="Account"
                    name="customer"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createDateTime"
                    label="Created At"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    label="Reported By"
                    name="employeeName"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="businessUnit"
                    label="Business Unit"
                  />
                  <FormInput
                    {...generalProps}
                    label="Activity Type"
                    name="activityType"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="department"
                    label="Department"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Category"
                    name="category"
                    isRequired
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                    disabled={isFormDisabled || isCSMAgent}
                    info={
                      form.watch("activityType")
                        ? ""
                        : "Select Activity Type To Load Data"
                    }
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="contract"
                    label="Contracts"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sub Category"
                    name="subCategory"
                    isRequired
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    disabled={isFormDisabled || isCSMAgent}
                    info={
                      form.watch("activityType") && form.watch("category")
                        ? ""
                        : "Select Activity Type & Category To Load Data"
                    }
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="requesterContactNo"
                    label="Contact Number"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    label="Assignment Group"
                    name="assignmentGroup"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="requesterEmail"
                    label="Email Id"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="reportingTo"
                    label="Reporting To"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="region"
                    label="Region"
                  />
                  {/* <FormInput
                    {...generalProps}
              
                    name="correlationId"
                    label="Correlation Id"
                    // rules={verificationRules.correlationId}
                  /> */}
                  {/* {form.watch("customerId") === "66e42d5af405de06de469b79" ? (
                    <FormInput
                      {...generalProps}
                
                      name="secondaryAssigneeId"
                      label="Secondary Assignee Id"
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                disabled
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  (isFormDisabled &&
                                    ticketDetails.status !== "Cancelled")
                                }
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            // isRequired={true}
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  isFormDisabled ||
                                  form.watch("In Progress") ||
                                  form.watch("Resolved") ||
                                  form.watch("Awaiting Customer Approval") ||
                                  form.watch("Awaiting Re-Opening")
                                }
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Tabs
                  defaultValue={
                    ticketDetails.status === "Cancelled" ||
                    ticketDetails.status === "Closed"
                      ? "notes"
                      : "resolutionNotes"
                  }
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>
                    <TabsTrigger
                      value="resolutionNotes"
                      disabled={
                        ticketDetails.status === "Cancelled" ||
                        ticketDetails.status === "Closed"
                      }
                    >
                      Resolution Notes
                    </TabsTrigger>
                    <TabsTrigger value="information">
                      Additional Information
                    </TabsTrigger>
                    <TabsTrigger value="requestDetails">
                      Request Details
                    </TabsTrigger>
                    <TabsTrigger value="accessTiming">
                      Access Timings
                    </TabsTrigger>
                    <TabsTrigger value="denomination">Denomination</TabsTrigger>
                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="System">system</TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        {isCCA ? (
                          <>
                            <FormField
                              control={form.control}
                              name="notesRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Work Notes" />

                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name="notesAdditionalRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Additional Comments" />
                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary mb-4"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />

                            <div className="flex flex-row w-full justify-end">
                              <Button variant="secondary" onClick={addNotes}>
                                Post
                              </Button>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>
                  <TabsContent value="resolutionNotes">
                    {ticketDetails?.activityType ? (
                      <ResolutionNotes
                        requestId={ticketDetails.ticketId}
                        ticket={ticketDetails}
                        ticketView
                      />
                    ) : (
                      <></>
                    )}
                  </TabsContent>
                  <TabsContent value="information">Coming Soon</TabsContent>
                  <TabsContent value="requestDetails">Coming Soon</TabsContent>
                  <TabsContent value="accessTiming">Coming Soon</TabsContent>
                  <TabsContent value="denomination">Coming Soon</TabsContent>
                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
